module.exports = __webpack_public_path__ + "img/snow.8e48fefb.png";